//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
import {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCardText,
  VContainer,
  VDialog,
  VFlex,
  VImg,
  VLayout,
} from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';
export default {
  name: 'NsModal',
  components: {
    NsIcon,
    VBtn,
    VCard,
    VCardActions,
    VCardTitle,
    VCardText,
    VContainer,
    VDialog,
    VFlex,
    VImg,
    VLayout,
  },
  props: {
    /**
     * Show or hide modal, using `v-model`
     */
    value: {
      type: Boolean,
      required: true,
    },
    /**
     * The title/header of the modal
     */
    title: String,
    /**
     * Modal width will be edge to edge of device
     */
    fullscreen: Boolean,
    /**
     * Force the modal open. Use persistent='false' to disable persistence
     */
    persistent: {
      type: Boolean,
      default: true,
    },
    /**
     * Style modal small, width: 300px
     */
    small: {
      type: Boolean,
      default: false,
    },
    /**
     * Confirm modal. This will have no close button nor icon for modal type (success, info, warning, error)
     */
    confirm: Boolean,
    /**
     * Adds icon that is relevant to a modal type (success, info, warning, error)
     */
    icon: { type: Boolean, default: false },
    /**
     * Modal type of image, styled as a 'card'
     */
    img: String,
    /**
     * Style modal as a info variant
     */
    info: {
      type: Boolean,
      default: false,
    },
    /**
     * Style modal as a success variant
     */
    success: {
      type: Boolean,
      default: false,
    },
    /**
     * Style modal as a error variant
     */
    error: {
      type: Boolean,
      default: false,
    },
    /**
     * Style modal as a warning variant
     */
    warning: {
      type: Boolean,
      default: false,
    },
    /**
     * Custom class
     */
    contextClass: {
      type: String,
      default: '',
    },
    /**
     * Attach modal inside of component instead of at the top of v-app
     */
    attach: {
      type: Boolean,
      default: false,
    },
    /** When set to true, expects a card, card-title, card-text and card-actions. Additionally, card-text should have specified height. Will set card-text to overflow-y */
    scrollable: {
      type: Boolean,
      default: false,
    },
    /** If scrollable this needs to have a value */
    contentHeight: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    dialog: {
      get() {
        // iOS hack to prevent background scrolling
        if (this.$vuetify && this.$vuetify.breakpoint.smAndDown) {
          // if dialog is open
          if (this.value) {
            this.hideScroll();
          } else {
            this.showScroll();
          }
        }
        return this.value;
      },
      set(value) {
        /**
         * Tells parent (using v-model) the display value
         * `input` value is needed when using v-model
         * @type {boolean}
         * @param {boolean} value tells parent display value
         */
        this.$emit('input', value);
      },
    },
    currentVariant() {
      if (this.success) {
        return {
          text: 'Success',
          class: 'modal-success',
          icon: 'icon-success-filled',
        };
      } else if (this.warning) {
        return {
          text: 'Warning',
          class: 'modal-warning',
          icon: 'icon-warning-filled',
        };
      } else if (this.error) {
        return {
          text: 'Error',
          class: 'modal-error',
          icon: 'icon-warning-filled',
        };
      } else if (this.info) {
        return {
          text: 'Information',
          class: 'modal-info',
          icon: 'icon-info-filled',
        };
      } else {
        return {
          text: null,
          class: this.contextClass || null,
          icon: null,
        };
      }
    },
    width() {
      // Width doesn't apply for fullscreen
      if (this.fullscreen) {
        return null;
      }
      return this.small ? 300 : 600;
    },
    showIcon() {
      // no icon for confirm modal
      // no icon when type is default
      return !this.confirm && !!this.currentVariant.icon && this.icon;
    },
  },
  methods: {
    /**
     * Sets v-model to false
     *
     * @public
     */
    onClose() {
      this.dialog = false;
      this.$emit('close');
    },
    hideScroll() {
      // iOS hack to prevent background scrolling
      if (this.$root.$el && this.$root.$el.closest('body')) {
        this.$root.$el.closest('body').classList.add('no-scroll');
      }
      window.addEventListener('wheel', this.scrollListener);
      window.addEventListener('keydown', this.scrollListener);
    },
    showScroll() {
      // iOS hack to prevent background scrolling
      if (this.$root.$el && this.$root.$el.closest('body')) {
        this.$root.$el.closest('body').classList.remove('no-scroll');
      }
      window.removeEventListener('wheel', this.scrollListener);
      window.removeEventListener('keydown', this.scrollListener);
    },
  },
};
